export default __webpack_public_path__ + "static/media/resolutaCoin.d4fb6573.svg";